import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { TableComponentProps } from '../types';

const columnLables = {
  aif_master_feeder_status: {
    name: 'Master or feeder fund type',
    order: 41,
    disabled: true
  }
};

export function MasterAifStatus({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.MASTER_AIF_STATUS,
    onChangeFund,
    schema: schema.MASTER_AIF_STATUS,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.MASTER_AIF_STATUS?.field_names || [],
    isMultiFunds,
    funds,
    columnLables,
    tableName: 'MASTER_AIF_STATUS'
  });

  return (
    <Table
      id="reporttables-master-aif-status-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
